export default __webpack_public_path__ + "static/media/Bestand_EDV_Papier.c94f9fa4.png";